import type { IconProps } from "./thumba-coin";

export const InfoPlayerIcon = (props: IconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="10" cy="10" r="9.33333" stroke="#176BF2" stroke-width="1.33333" />
    <path
      d="M9.14205 16.5V7.77273H10.8409V16.5H9.14205ZM10 6.42614C9.70455 6.42614 9.45076 6.32765 9.23864 6.13068C9.0303 5.92992 8.92614 5.69129 8.92614 5.41477C8.92614 5.13447 9.0303 4.89583 9.23864 4.69886C9.45076 4.49811 9.70455 4.39773 10 4.39773C10.2955 4.39773 10.5473 4.49811 10.7557 4.69886C10.9678 4.89583 11.0739 5.13447 11.0739 5.41477C11.0739 5.69129 10.9678 5.92992 10.7557 6.13068C10.5473 6.32765 10.2955 6.42614 10 6.42614Z"
      fill="#176BF2"
    />
  </svg>
);
